<template>
  <div style="cursor: move" v-if="window">
    <b-row
      :class="
        'col-lg-12 remove-window-spacing ' +
        (showModal ? 'window-width' : 'window-widthfixed')
      "
    >
      <b-col :class="showModal ? 'col-lg-4' : 'col-lg-0'">
        <div class="notes_panel scroll-Container" v-if="showModal">
          <h6 class="text-center my-1"><strong>Notes Template</strong></h6>
          <b-row v-for="element in ansi_notes" :key="element.id">
            <b-col class="my-1 mx-1">
              <b-button
                title="Click to paste in Notes."
                :key="element.note"
                :id="element.id"
                @click="pushToNotes(element.note)"
                size="sm"
                class="btn ansi-button text-left"
                variant="btn-primary"
              >
                * {{ element.note }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col :class="showModal ? 'col-lg-8' : 'col-lg-12'" style="padding: 0">
        <div>
          <b-card class="panel scroll-Container">
            <b-row class="my-2">
              <b-col>
                <b-button
                  id="submitAnsiBtn"
                  size="sm"
                  class="btn greenBtn"
                  variant="btn-primary"
                  block
                  @click="updateSite"
                >
                  Update
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  size="sm"
                  class="btn ansi-button"
                  variant="btn-primary"
                  id="togglePass"
                  block
                  @click="togglePass()"
                >
                  Toggle Pass
                </b-button>
                <fa
                  size="lg"
                  class="close-button"
                  :icon="['fas', 'window-close']"
                  @click="closeWindow()"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label
                    ><b>Intersection ID:</b> {{ this.intersectionId }}</label
                  >
                </b-col>
                <b-col class="col-md-6">
                  <label><b>SEGMENT ID:</b> {{ this.segmentId }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>TECHNICIAN:</b> {{ this.technician }}</label>
                </b-col>
                <b-col class="col-md-6" v-if="apiUrl == 'ansi_gm'">
                  <label><b>PART NUMBER:</b> {{ this.part_number }}</label>
                </b-col>
              </b-row>
              <b-row class="col-md-12 py-1 mx-3">
                <b-col class="col-md-6">
                  <label><b>STATE: </b>{{ this.state_name }}</label>
                </b-col>
              </b-row>
            </b-row>
            <b-row>
              <b-col>
                <label class="notes">Notes</label>
                <fa
                  size="lg"
                  title="Open Notes Template"
                  class="greenBtn testingWindowNotes"
                  :icon="['fas', 'angle-down']"
                  @click="showNotesModal()"
                />
                <b-form-textarea
                  id="notes"
                  @mouseup="enableInput($event)"
                  @mousedown="enableInput($event)"
                  rows="4"
                  cols="50"
                  style="resize: none"
                  class="contenteditable-element"
                  v-model="notes"
                  ref="notes"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="boxed py-1 px-4 mt-2" align-v="center">
              <b-col>
                <label class="my-1 mx-3"
                  ><b style="font-size: 24px">REQUIRED</b></label
                >
              </b-col>
            </b-row>
            <b-row
              align-h="between"
              class="py-1 px-5 mt-2"
              v-for="prop in ansiProperties"
              :key="prop.id"
            >
              <b-col cols="7" class="p-2">
                <span>
                  <strong>{{ prop.prop }}</strong>
                </span>
              </b-col>
              <b-col cols="5">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                  <label
                    :class="
                      prop.value == 'not_validated'
                        ? 'btn grayBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'not_validated'"
                      :name="prop.prop"
                      id="option1"
                      autocomplete="off"
                      value="not_validated"
                      title="Not Validated"
                      @change="changed($event, prop.prop)"
                    />
                    <span
                      class="glyphicon glyphicon-eye-close"
                      title="Not Validated"
                    >
                      <fa :icon="['fas', 'eye-slash']" />
                    </span>
                  </label>
                  <label
                    :class="
                      prop.value == 'indeterminate'
                        ? 'btn yellowBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'indeterminate'"
                      :name="prop.prop"
                      id="option2"
                      autocomplete="off"
                      value="indeterminate"
                      title="Indeterminate"
                      @change="changed($event, prop.prop)"
                    />
                    <span
                      class="glyphicon glyphicon-warning-sign"
                      title="Indeterminate"
                    >
                      <fa :icon="['fas', 'exclamation-triangle']" />
                    </span>
                  </label>
                  <label
                    :class="
                      prop.value == 'fail'
                        ? 'btn redBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'fail'"
                      :name="prop.prop"
                      id="option3"
                      autocomplete="off"
                      value="fail"
                      title="Fail"
                      @change="changed($event, prop.prop)"
                    />
                    <span class="glyphicon glyphicon-thumbs-down" title="Fail">
                      <fa :icon="['fas', 'thumbs-down']" />
                    </span>
                  </label>
                  <label
                    :class="
                      prop.value == 'pass'
                        ? 'btn greenBtn'
                        : 'btn unSelectedIcons'
                    "
                  >
                    <input
                      type="radio"
                      :checked="prop.value == 'pass'"
                      :name="prop.prop"
                      id="option4"
                      autocomplete="off"
                      value="pass"
                      title="Pass"
                      @change="changed($event, prop.prop)"
                    />
                    <span class="glyphicon glyphicon-thumbs-up" title="Pass">
                      <fa :icon="['fas', 'thumbs-up']" />
                    </span>
                  </label>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_Intersection_Testing',
  props: ['apiUrl', 'layerDefinition', 'hdLayerSelected', 'user'],
  data() {
    return {
      ansiProperties: [],
      window: true,
      ansi_notes: [],
      getApiUrl: '/api/' + this.apiUrl,
      notes: null,
      opts: [],
      part_number: null,
      properties: [],
      required_props: [],
      road_type: null,
      segmentId: null,
      showModal: false,
      state_name: null,
      technician: null,
      ushrId: null,
      osm_id: null,
      validateOverallStatus: null,
      intersectionId: null
    }
  },
  methods: {
    closeWindow() {
      this.window = false
    },
    updateSite() {
      let opts = []
      this.ansiProperties.forEach(ob => {
        opts.push(ob.prop, ob.value)
      })
      // Flatten the array
      opts = opts.flat()
      // Create an empty object
      let obj = {}
      for (let i = 0; i < opts.length; i++) {
        if (i % 2 == 0) {
          // Extract the key and the value
          let key = opts[i]
          let value = opts[i + 1]
          // Assign the key and value
          obj[key] = value
        }
      }
      let opts_param = {
        intersectionId: this.intersectionId,
        segmentId: this.segmentId,
        tech: this.user.name,
        notes: this.notes,
        passed: this.getStatus(),
        Overall: this.getStatus()
      }
      this.validateOverallStatus = opts_param.Overall
      if (this.validateOverallStatus != 'not_validated') {
        var mergedObj = Object.assign(obj, opts_param)
        axios
          .get(
            process.env.API_LOCATION + this.getApiUrl + '/updateIntersection',
            {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {mergedObj}
            }
          )
          .then(response => {
            const content = response.data
            this.$bvToast.toast('Entry saved.', {
              title: 'Intersection Submission Status',
              toaster: 'b-toaster-top-center'
            })
          })
          .catch(function (error) {
            console.log(error)
          })
        this.closeWindow()
      } else {
        this.$bvToast.toast('Please confirm Intersection is validated.', {
          title: 'Intersection Submission Status',
          toaster: 'b-toaster-top-center'
        })
      }
    },
    getStatus() {
      var values = []
      this.ansiProperties.forEach(radios => {
        values.push({name: radios.value, type: radios.type})
      })
      if (
        values.filter(e => e.name === 'not_validated' && e.type === 'required')
          .length > 0
      ) {
        return 'not_validated'
      } else if (values.filter(e => e.name === 'fail').length > 0) {
        return 'fail'
      } else {
        return 'pass'
      }
    },
    togglePass() {
      this.properties = []
      this.properties = this.ansiProperties
      this.ansiProperties = []
      this.properties.forEach(val => {
        this.ansiProperties.push({
          prop: val.prop,
          value: 'pass',
          type: val.type
        })
      })
    },
    /* loadAnsiData function gets the data generated by the single-click event
       from parent and renders the data in the ANSI Testing Window */
    loadAnsiData(data) {
      if (data != null) {
        this.window = true
        var feature = data.properties
        this.segmentId = feature.segment_id
        this.state_name = feature.region
        this.road_type = feature.type
        this.technician = feature.technician
        this.notes = feature.notes
        this.part_number = feature.part_number
        this.intersectionId = feature.intersection_id
        this.ansiProperties = []
        this.properties = []
        axios
          .get(
            process.env.API_LOCATION +
              this.getApiUrl +
              '/getIntersectionProperties',
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                layerSelected: this.hdLayerSelected
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.properties = content.rows
              this.getRequiredProps()
              let index = this.properties.length
              Object.entries(feature).forEach(element => {
                const [key, value] = element
                let val = this.properties.find(elem => elem.name === key)
                if (val != undefined) {
                  let props = this.required_props.filter(e => e.name === key)
                  if (value == null || value == '') {
                    this.ansiProperties.push({
                      prop: key,
                      value: 'not_validated',
                      type: props.length > 0 ? 'required' : '',
                      id: index
                    })
                  } else {
                    this.ansiProperties.push({
                      prop: key,
                      value: value,
                      type: props.length > 0 ? 'required' : '',
                      id: index
                    })
                  }
                }
                index = index - 1
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    changed(e, prop) {
      var checkedLabel = e.target
      const index = this.ansiProperties.findIndex(item => {
        return prop === item.prop
      })
      this.ansiProperties[index].value = checkedLabel.value
    },
    enableInput(e) {
      /* Vue-Moveable js disabled the left-click event in order to increase convenience
      for dragging the window and enabled right-click to set the focus on textarea and
      input box, hence this function resets that. */
      e.target.contentEditable = 'true'
      this.$refs.notes.focus()
    },
    getRequiredProps() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              this.getApiUrl +
              '/getRequiredIntersectionProps',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.required_props = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    },
    getAnsiNotes() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/getAnsiNotes', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              this.$router.push({name: 'Login'})
            } else {
              this.ansi_notes = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.feedback = 'No Apps For you'
        this.$router.push({name: 'Login'})
      }
    },
    pushToNotes(value) {
      this.notes = value
      this.showModal = false
    },
    showNotesModal() {
      this.showModal = !this.showModal
    }
  },
  mounted() {
    this.getRequiredProps()
    this.getAnsiNotes()
  },
  updated() {
    this.$emit('ansiTestingDataUpdated')
  }
}
</script>

<style scoped>
.panel {
  max-height: 80vh;
  background: rgba(6, 47, 86, 0.6);
  color: #e6e6e6;
  overflow-y: scroll;
  overflow-x: hidden;
}
.contenteditable-element {
  user-select: text;
}
.menu-bg-blue-transparent-modal {
  background: rgb(34, 34, 34);
  color: rgb(238, 238, 238);
  line-height: 1.25;
  text-shadow: 0.5px 0.5px black;
}
.boxed {
  border: 1px solid #21d886;
}
.window-widthfixed {
  width: min(40.625rem, 90vw) !important;
}
.window-width {
  width: min(57.5rem, 90vw) !important;
}
.remove-window-spacing {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
}
.btn {
  color: #e6e6e6;
}
</style>
